<template>
  <v-row class="ma-0">
    <v-row v-if="loadingTranslations" justify="center" class="py-5">
      <v-progress-circular
          indeterminate
          color="primary"
          :size="50"
      >
      </v-progress-circular>
    </v-row>
    <v-card width="100%" class="ma-1" v-else>
      <v-card-text>
        <v-row v-for="item in filteredTranslations" justify="center" v-bind:key="item.id">
          <v-col class="col-lg-4 col-6">
            <v-subheader class="text-right">
              {{ item.combinedKey }}
            </v-subheader>
          </v-col>
          <v-col cols="6">
            <v-text-field
                v-model="item.newText"
                @change="addTranslation(item)"
            >
            </v-text-field>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-row>
</template>

<script>
import {mapState, mapActions} from 'vuex';
import eventBus from "../../../../event-bus/eventBus";


export default {
  name: "TranslationListForm",
  props: {
    translationItems: Array,
  },
  data() {
    return {
      searchTranslation: '',
    }
  },
  computed: {
    ...mapState("getTranslationModule", {
      loadingTranslations: state => state.loadingTranslations
    }),
    ...mapState("updateTranslation", {
      changedItems: state => state.changedItems
    }),
    filteredTranslations() {
      if(this.translationItems) {
        return this.translationItems.filter(el => {
          return el.text.toLowerCase().includes(this.searchTranslation.toLowerCase())
        })
      }
      return this.translationItems;
    },
  },
  methods: {
    ...mapActions("updateTranslation", ["addToChangedItems"]),

    addTranslation(item) {
      this.addToChangedItems(item)
    },
  },
  mounted() {
    eventBus.$on('filterTranslation', (search) => {
      this.searchTranslation = search;
    });
  },

}
</script>
